import React from "react"
import { Button, Input } from "reactstrap"
import classnames from "classnames"
import { PulseLoader } from "react-spinners"

const RegisterForm = ({
  isLoading,
  onSignUpClick,
  errors,
  onEmailAddressChange,
  emailAddress
}) => {

  return (
    <form onSubmit={onSignUpClick}>
      <div>
        <div className="wrap-register-form-input">
          <Input
            className={classnames("register-form-input", {
              "has-val": emailAddress !== "",
            })}
            type="text"
            name="email_address"
            value={emailAddress}
            onChange={onEmailAddressChange}
            autoFocus
          />
          <span
            className="register-form-input-span"
            data-placeholder="Business Email"
          ></span>
        </div>
        {errors.emailAddress ? <p className="register_mail_error">{errors.emailAddress}</p> : null}
      </div>
      {errors.captchaToken ? <p className="register_phone_error captcha_token">{errors.captchaToken}</p> : null}
      {
        !isLoading ? (
          <Button
            type='submit'
            className='btn-clearout'
            disabled={isLoading || errors.emailAddress}
          >Continue
          </Button>
        ) :
          <div className="custom-pulse-loader-color d-flex justify-content-center">
            <PulseLoader size={10} cssOverride={{ marginBottom: "-4px" }} />
          </div>
      }
    </form>
  )
}

export default RegisterForm;